export const frequencyMultiplier = {
  WEEKLY: 52 / 12,
  FORTNIGHTLY: 26 / 12,
  MONTHLY: 1,
};

export const parseAmount = (value) => {
  if (value == null || value === '') return 0;
  return parseFloat(String(value).replace(/,/g, '')) || 0;
};

export const getMultiplier = (frequency) => frequencyMultiplier[frequency] || 1;

export const shouldHideAccommodation = (status, OWN_MORTGAGE, OWN_NO_MORTGAGE) => (
  status === OWN_MORTGAGE || status === OWN_NO_MORTGAGE
);

export const calcLivingExpenses = ({
  essentialExpenses,
  essentialFreq,
  nonEssentialExpenses,
  nonEssentialFreq,
  willForgoNonEssentials,
}) => {
  const essentialCost = parseAmount(essentialExpenses) * getMultiplier(essentialFreq);
  const nonEssentialMonthlyCost = parseAmount(nonEssentialExpenses)
    * getMultiplier(nonEssentialFreq);
  const nonEssentialCost = willForgoNonEssentials ? 0 : nonEssentialMonthlyCost;
  return Number((essentialCost + nonEssentialCost).toFixed(2));
};

export const formatAmount = (n) => (Number.isFinite(n) ? n.toFixed(2) : '0.00');
